import { FC } from 'react'
import styles from './circleSteps.module.scss'

// This component takes an array of paths and an index, and returns a numbered sequence of
// circles to indicate progression through the sequence of pages supplied. The array being a sequence of paths
// is a holdover from the circles initally being clickable links, and has been left
// in case there is the desire to change back in the future.
type Props = {
  stepArray: string[]
  path: string
}

const CircleSteps: FC<Props> = ({ stepArray, path }) => {
  const currentIndex = stepArray.indexOf(path)
  const steps = stepArray.map((_, index) => {
    // Initial step is always the same
    if (index === 0)
      return (
        <span key={index}>
          <div className={`${styles.circle} ${styles.filled}`}>
            <span className={styles.number}>1</span>
          </div>
        </span>
      )
    // Otherwise we return empty circle/line pairs for pages futher in the sequence
    else
      return index > currentIndex ? (
        <span key={index}>
          <div className={styles.line}></div>
          <div className={styles.circle}>
            <span className={styles.number}>{index + 1}</span>
          </div>
        </span>
      ) : (
        // And filled circle/line pairs for the current and all past pages
        <span key={index}>
          <div className={`${styles.line} ${styles.filled}`}></div>
          <div className={`${styles.circle} ${styles.filled}`}>
            <span className={styles.number}>{index + 1}</span>
          </div>
        </span>
      )
  })

  return (
    <div className="text-center">
      <span className="d-none d-sm-inline-block py-5">{steps}</span>
      <span className="d-inline-block d-sm-none py-3 small">{steps}</span>
    </div>
  )
}

export { CircleSteps }
